import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import {
  selectAllocations,
  selectAllocationsPagination,
  selectAllocationsFilter,
  fetchAllocationsActions,
  setAllocationsFilterAction,
} from '../ducks';
import { AllocationList } from '../components';
import { apiCallIds as allocationApiCallIds } from '../api';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { selectToken } from '../../../features/auth/ducks';

const mapStateToProps = state => ({
  allocations: selectAllocations(state),
  pagination: selectAllocationsPagination(state),
  filter: selectAllocationsFilter(state),
  token: selectToken(state),
  isLoading: selectIsInProgress(state, allocationApiCallIds.FETCH_ALLOCATIONS),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAllocations: fetchAllocationsActions.request,
      setFilter: setAllocationsFilterAction,
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class AllocationListContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    allocations: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    token: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { filter, actions } = this.props;
    actions.fetchAllocations({
      ...filter,
    });
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.props.pagination.current = pagination.current;
    this.props.actions.fetchAllocations({
      ...this.props.filter,
      pageNo: pagination.current - 1,
    });
  };

  onFilterChange = filterKey => filterValue => {
    const { filter, actions } = this.props;
    actions.setFilter({
      ...filter,
      [filterKey]: filterValue,
    });
  };

  onFilterStatusChange = this.onFilterChange('status');

  render() {
    const { allocations, pagination, filter, isLoading, t, token } = this.props;

    return (
      <div>
        <h1>{t('Investície')}</h1>

        <AllocationList
          allocations={allocations}
          pagination={pagination}
          filter={filter}
          onTableChange={this.handleTableChange}
          onFilterStatusChange={this.onFilterStatusChange}
          isLoading={isLoading}
          token={token}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocation-management/containers/AllocationListContainer.js